<template>
  <li
    class="pb-tag-filter-item"
  >
    <PbLink
      exact
      :to="destination"
      :class="{ 'txt-muted': !tag.defaultPresets.size }"
    >
      <span class="pb-tag-filter-item-name">
        {{ tag.name }}
      </span>
      <UiBadge class="pb-tag-filter-item-count">
        {{ tag.defaultPresets.size }}
      </UiBadge>
    </PbLink>
    <TagFilters
      :route-name="link"
      :tag="tag"
      :root="false"
    />
  </li>
</template>

<script setup>
import PbLink from '@/components/PbLink.vue'
import TagFilters from '@/components/TagFilters.vue'
import useDestination from '@/composables/useDestination'
import UiBadge from '@nicolaudie-group/ng-ui-kit/components/UiBadge/UiBadge.vue'
import { computed } from 'vue'

const props = defineProps({
  tag: { type: Object, required: true },
  link: { type: String, required: true },
})

const to = computed(() => ({
  name: props.link,
  params: {
    tag: props.tag.pathArr,
  },
}))

const destination = useDestination(to)
</script>
